import { __assign } from "tslib";
import { ActionIntent, ExecutionMode, } from '@office-start/action-types';
import { OfficeActionCreators } from './officeActionCreators';
import { getSubEntityObject, isAppExecutionInfo, isExternalAppExecutionInfo, isExternalUrlExecutionInfo, isInContextAppExecutionInfo, isInContextExternalUrlExecutionInfo, } from './util';
var getOptionsFromDefinition = function (definition, content) {
    var requiredForNextAction;
    if (definition.nextAction) {
        requiredForNextAction = {
            nextAction: definition.nextAction,
            content: content,
        };
    }
    return __assign(__assign({}, requiredForNextAction), { notificationOptions: definition.metadata.notificationOptions });
};
/**
 * @description Takes in action definitions from app service and translates them to OfficeActions
 * @param content content that action is being applied to
 * @param definition definition to convert
 * @returns A supported office action or undefined
 */
export var getOfficeAction = function (content, definition) {
    var executionInfo = definition.executionInfo;
    var shouldIncludeSubEntityInformation = definition.intent === ActionIntent.ContentEdit ||
        ActionIntent.ContentView;
    switch (executionInfo.mode) {
        case ExecutionMode.DeepLinkToApp:
            // If viewing or creating content, add in subEntity information
            var subEntityInformation = void 0;
            if (shouldIncludeSubEntityInformation) {
                subEntityInformation = JSON.stringify(getSubEntityObject(content));
            }
            // Navigate to app with given target
            if (isExternalAppExecutionInfo(executionInfo)) {
                // Add in action creator for this piece of content.
                return OfficeActionCreators.createNavigateToAppExternal(executionInfo.appId, executionInfo.entityId, executionInfo.target, subEntityInformation, getOptionsFromDefinition(definition, content));
            }
            // Navigate to app in current hub
            if (isAppExecutionInfo(executionInfo)) {
                // Add in action creator for this piece of content.
                return OfficeActionCreators.createNavigateToApp(executionInfo.appId, executionInfo.entityId, subEntityInformation, getOptionsFromDefinition(definition, content));
            }
            break;
        case ExecutionMode.OpenExternal:
            if (isExternalUrlExecutionInfo(executionInfo)) {
                return OfficeActionCreators.createLaunchUrlAction(executionInfo.url, executionInfo.target, getOptionsFromDefinition(definition, content));
            }
            break;
        case ExecutionMode.Submit:
        // This is where the bot framework and API calls will hook into
        case ExecutionMode.InContextUx:
            if (isInContextExternalUrlExecutionInfo(executionInfo)) {
                return OfficeActionCreators.createLaunchUrlAction(executionInfo.url, '_blank', getOptionsFromDefinition(definition, content));
            }
            if (isInContextAppExecutionInfo(executionInfo)) {
                return OfficeActionCreators.createLaunchAppInContextAction(executionInfo.appId, executionInfo.entityId, subEntityInformation, getOptionsFromDefinition(definition, content));
            }
            break;
        default:
            break;
    }
    // $TODO: evlave - log unsupported execution mode or invalid execution info
    return undefined;
};
//# sourceMappingURL=officeActionCreator.js.map